"use strict";

/**
 * **Used for iOS only:** The evaluation policy to use when accessing the credentials. Defaults to LocalAuthenticationStrategy.deviceOwnerWithBiometrics.
 */
var LocalAuthenticationStrategy = /*#__PURE__*/function (LocalAuthenticationStrategy) {
  /**
   * User authentication with biometry.
   */
  LocalAuthenticationStrategy[LocalAuthenticationStrategy["deviceOwnerWithBiometrics"] = 1] = "deviceOwnerWithBiometrics";
  /**
   * User authentication with biometry, Apple Watch, or the device passcode.
   */
  LocalAuthenticationStrategy[LocalAuthenticationStrategy["deviceOwner"] = 2] = "deviceOwner";
  return LocalAuthenticationStrategy;
}(LocalAuthenticationStrategy || {});
export default LocalAuthenticationStrategy;
//# sourceMappingURL=localAuthenticationStrategy.js.map